<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import AllHeader from './components/Header.vue';//公用头部
import BotToms from './components/Bottom.vue';//公用底部

export default {
  name: 'app',
  components: {
    AllHeader,
    BotToms
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    if (screen.width <= 750) {
      window.location.href = 'http://m.sjzd1879.com/'
    }
    document.title = '世界至德';
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },

}
</script>

<style>
html,
body,
#app {
  padding: 0px;
  margin: 0px;
  background: #fff;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

a {
  text-decoration: none;
}

li {
  list-style-type: none;
}

p {
  margin: 0;
  padding: 0;
}

.el-header {
  padding: 0 !important;
  height: 100% !important;
}

.reinfo-uppic .el-upload--picture-card {
  width: 72px;
  height: 72px;
  line-height: 80px;
}

.vl-notify.vl-notify-msg {
  z-index: 99999 !important;
}

.vl-notify.vl-notify-loading {
  z-index: 99999 !important;
}
</style>
